var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSbbInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SBB_him_info",
    focusable: "false",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 4.85c0-1 .8-1.9 1.9-1.9 1 0 1.8.8 1.8 1.9 0 1-.8 1.8-1.8 1.8-1.1 0-1.9-.8-1.9-1.8zm-1.1 11.4h1.2v-8H7.2c-.2 0-.3-.1-.3-.3s.1-.4.3-.4h4.5v8.7h1.1c.2 0 .4.2.4.4s-.2.4-.4.4H7.2c-.2 0-.4-.199-.4-.399s.2-.401.4-.401z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbbInfoIcon);
export default __webpack_public_path__ + "static/media/sbb_info_icon.1d8216b59c815bb8d5a89985cbadb3b0.svg";
export { ForwardRef as ReactComponent };